import { z } from 'zod';
import { procurementCurrencyCodeSchema, procurementMoneyCentsSchema } from './procurement-order.contract.js';
export const procurementFinanceProfitabilityCostsCapability = 'procurement.finance-profitability-costs.v1';
export const procurementFinanceProfitabilityCostsSlot = 'finance.project-profitability.procurement-costs';
export const procurementFinanceProfitabilityCostsProviderId = 'procurement.server.finance-profitability-costs';
export const procurementFinanceProfitabilityCostsRequestSchema = z.strictObject({
    consumerModuleId: z.literal('finance'),
    requestedCapability: z.literal('finance.project-profitability.v1'),
    resourceType: z.literal('finance.project-profitability'),
    resourceId: z.string().uuid(),
    projectIds: z.array(z.string().uuid()).min(1).max(500),
}).superRefine((request, context) => {
    if (new Set(request.projectIds).size !== request.projectIds.length) {
        context.addIssue({ code: 'custom', path: ['projectIds'], message: 'Procurement Projects cannot repeat.' });
    }
});
export const procurementFinanceProfitabilityProjectCostsSchema = z.discriminatedUnion('state', [
    z.strictObject({
        state: z.literal('present'),
        projectId: z.string().uuid(),
        currencyCode: procurementCurrencyCodeSchema.nullable(),
        orderCount: z.number().int().nonnegative(),
        openOrderCount: z.number().int().nonnegative(),
        materialOrderCount: z.number().int().nonnegative(),
        subcontractOrderCount: z.number().int().nonnegative(),
        materialCostCents: procurementMoneyCentsSchema,
        subcontractorCostCents: procurementMoneyCentsSchema,
        totalProcurementCostCents: procurementMoneyCentsSchema,
    }).superRefine((fact, context) => {
        if (fact.totalProcurementCostCents !== fact.materialCostCents + fact.subcontractorCostCents) {
            context.addIssue({ code: 'custom', path: ['totalProcurementCostCents'], message: 'Procurement costs do not reconcile.' });
        }
        if (fact.orderCount === 0 && (fact.currencyCode !== null || fact.openOrderCount !== 0 || fact.materialOrderCount !== 0 ||
            fact.subcontractOrderCount !== 0 || fact.totalProcurementCostCents !== 0)) {
            context.addIssue({ code: 'custom', path: [], message: 'Empty Procurement facts must be exact zero.' });
        }
    }),
    z.strictObject({
        state: z.literal('unavailable'),
        projectId: z.string().uuid(),
        reasonCode: z.enum(['permission-denied', 'project-unavailable', 'cost-basis-incomplete']),
    }),
]);
export const procurementFinanceProfitabilityCostsResponseSchema = z.strictObject({
    contractVersion: z.literal(procurementFinanceProfitabilityCostsCapability),
    tenantId: z.string().uuid(),
    projects: z.array(procurementFinanceProfitabilityProjectCostsSchema).min(1).max(500),
});
//# sourceMappingURL=procurement-finance-profitability-costs.contract.js.map